export enum SortDirection {
  Ascending = "asc",
  Descending = "desc",
}

export const sortDirectionToNameMap = {
  [SortDirection.Ascending]: "Ascending",
  [SortDirection.Descending]: "Descending",
};

export interface IPage<TEntity> {
  data: TEntity[];
  count: number;
}

export interface ITruncatedPaged<TEntity> extends IPage<TEntity>{
  marker?: string;
}

export interface IPageRequestParams<TOffset = number> {
  offset?: TOffset;
  pageSize?: number;
}

export interface ISortRequestParams<T> {
  field?: T;
  order?: SortDirection;
}

export interface IRequestParams<TSortField=string> extends IPageRequestParams, ISortRequestParams<TSortField> {
}

export interface IDeletedParam {
  deleted?: boolean;
}

export interface IQueryStrictParams {
  q?: string;
  strict?: boolean;
}
